import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import StatsComponent from './container/StatsComponent';
import ServicesCount from './container/ServicesCount';
import CollectionsGraph2 from './container/CollectionsGraph2';
import StatisticsContainer from './container/StatisticsContainer';
import MapComponent from './components/MapComponent';
import CmsContext from '../../context/CmsContext';
import LasPinasStatisticsContainer from './container/las-pinas/LasPinasStatisticsContainer';
import StatsComponentV2 from './container/smart-city/StatsComponentV2';
import ServicesCountV2 from './container/smart-city/ServicesCountV2';
import CollectionsGraphV2 from './container/smart-city/CollectionsGraphV2';

function MainDashboardContainer() {
  const cmsContext = useContext(CmsContext)
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  return (
    <div className="container-fluid p-4 mb-3">
      <div className="row">
        <div className="col-md-12 px-1 mb-3">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <StatsComponentV2 /> : <StatsComponent />}
        </div>
      </div>
      {/* pie chart */}
      <div className="row mt-1">
        <div className="col-md-12 px-1">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <ServicesCountV2 /> : <ServicesCount lgu={_.get(CMS_VARIABLES, 'LGU_NAME')} />}
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-md-12">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <CollectionsGraphV2 /> : <CollectionsGraph2 />}
        </div>
      </div>

      <div className="row mt-1 statistics">
        <div className="col-md-8 stat-inner pr-3">
          {_.get(CMS_VARIABLES, 'LGU_NAME') === "Las Piñas" ? <LasPinasStatisticsContainer /> : <StatisticsContainer />}
        </div>
        <div className="col-md-4 stat-inner">
          <MapComponent />
        </div>
      </div>
    </div>
  );
}

MainDashboardContainer.propTypes = {};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MainDashboardContainer);
